import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import Dropdown from "components/forms/inputs/dropdown";
import { OptionInterface } from "components/forms/inputs/dropdown.styles";
import TextInput from "components/forms/inputs/text";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import Modal from "components/layout/modal";
import { useLocale, useLocales } from "stores/hooks/locale";
import { createEmpty, parse } from "lib/locale";
import { showError } from "lib/notification";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import { adminDoPostList } from "services/admin/list";
import { fetchLists } from "stores/actions/lists";
import * as yup from "yup";
import { useListTemplates } from "stores/hooks/list-templates";
import { fetchListTemplates } from "stores/actions/list-templates";

interface NewListModalProps {
  onClose: () => Promise<void>;
}

const NewListModal: FunctionComponent<NewListModalProps> = ({ onClose }) => {
  const locales = useLocales();
  const locale = useLocale();
  const navigate = useNavigate();
  const listTemplates = useListTemplates();

  const options = listTemplates.map((lta) => {
    const name = parse(lta.name, locale);
    const count = lta.lists.length;
    const option: OptionInterface = {
      value: lta.uuid,
      text: `${name} (luetteloita ${count})`,
    };
    return option;
  });

  const schema = yup
    .object({
      name: yup.object().validateLocaleString(),
      list_template_uuid: yup.string().validateRequired(),
    })
    .required();

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: createEmpty("Uusi luettelo", locales),
      list_template_uuid: options.find((o) => o.disabled === false)?.value,
    },
  });

  const handleSubmit = async (formValues: any) => {
    const { name, list_template_uuid } = formValues;

    try {
      // create list
      const list = await adminDoPostList(name, list_template_uuid);

      // update lists and list of available list types
      fetchLists();
      fetchListTemplates();

      // navigate to new list
      navigate(`/admin/list/${list.uuid}`);
    } catch (err) {
      showError("Luettelon luominen epäonnistui");
    }
  };

  const buttons: FormButtonInterface[] = [
    { ...CancelButton, onClick: onClose },
    { ...SubmitButton },
  ];

  return (
    <Modal title="Uusi luettelo">
      <Form methods={methods} onSubmit={handleSubmit}>
        <Grid>
          <Row>
            <Col>
              <TextInput
                name="name"
                translations
                label="Luettelon nimi"
                required
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Dropdown
                name="list_template_uuid"
                label="Käytettävä luettelomalli"
                options={options}
              />
            </Col>
          </Row>
        </Grid>
        <FormButtons buttons={buttons} />
      </Form>
    </Modal>
  );
};

export default NewListModal;
